import { lastUtils } from '@last/core'

let available = false

async function load(pixelId, router) {
  if (typeof fbq === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    )
    let ids = pixelId.split(',')
    ids.forEach(id => {
      fbq('init', id)
    })
  }
  trackPageViews(router)
  available = true
}

function trackPageViews(router) {
  fbq('track', 'PageView')
  router.afterEach(() => {
    fbq('track', 'PageView')
  })
}

function isAvailable() {
  return available
}

function mapProducts(products) {
  return products.map(product => {
    let price = product.finalPrice
    if (!price) price = product.price
    return {
      id: product.id,
      name: product.name,
      quantity: product.quantity,
      value: lastUtils.round(price / 100)
    }
  })
}

async function checkoutCompleted({ products, totalPrice, currencyCode }) {
  fbq('track', 'Purchase', {
    contents: mapProducts(products),
    content_type: 'product',
    currency: currencyCode || 'EUR',
    value: lastUtils.round(totalPrice / 100)
  })
}

async function beginCheckout({ products, totalPrice, currencyCode }) {
  let mapedProducts = mapProducts(products)
  fbq('track', 'InitiateCheckout', {
    content_ids: mapedProducts.map(p => p.id),
    contents: mapedProducts,
    currency: currencyCode,
    num_items: mapedProducts.map(p => p.quantity).reduce((a, b) => a + b),
    value: lastUtils.round(totalPrice / 100)
  })
}

async function addProductToCart({ product, currencyCode }) {
  let item = mapProducts([product])[0]
  fbq('track', 'AddToCart', {
    contents: [item],
    content_type: 'product',
    currency: currencyCode,
    value: item.value
  })
}

async function itemViewed({ item, currencyCode }) {
  item = mapProducts([item])[0]
  fbq('track', 'ViewContent', {
    content_id: item.id,
    content_name: item.name,
    currency: currencyCode,
    value: item.value
  })
}

async function bookingOnGoing() {
  fbq('trackCustom', 'BookingOnGoing')
}

async function bookingDone() {
  fbq('trackCustom', 'BookingDone')
}

function newLead() {
  fbq('track', 'Lead')
}

export default {
  checkoutCompleted,
  beginCheckout,
  isAvailable,
  addProductToCart,
  itemViewed,
  bookingOnGoing,
  bookingDone,
  load,
  newLead
}
